export enum TreeLevel {
  UseCaseRoot = 1,
  Master = 2,
  Instance = 3,
  Group = 4,
  Channel = 5,
}
